import PowerGripDragoons from "./power-grip-dragoons/power-grip-dragoons";
import TrajectileCommand from "./trajectile-command/trajectile-command";
import SensorToolkit from "./sensor-toolkit/sensor-toolkit";
import EnergyBars from "./energy-bars/energy-bars";
import ColonialKartWorld from "./colonial-kart-world/colonial-kart-world";
import GazooRacing from "./gazoo-racing/gazoo-racing";
import Camry from "./camry/camry";
import RaymarchingPlanet from "./raymarching-planet/raymarching-planet";
import AngryPi from "./angrypi/angrypi";

export default [
  { title: "VR" },
  { title: "Power Grip Dragoons", component: PowerGripDragoons },
  { title: "Trajectile Command", component: TrajectileCommand },
  { title: "Unity" },
  { title: "Sensor Toolkit", component: SensorToolkit },
  { title: "MOBA Style Energy Bars", component: EnergyBars },
  { title: "Colonial Kart World", component: ColonialKartWorld },
  { title: "WebGL" },
  { title: "Toyota Japan Gazoo Racing Configurator", component: GazooRacing },
  { title: "Toyota Camry Configurator", component: Camry },
  { title: "Other" },
  { title: "Raymarching Planet Shader", component: RaymarchingPlanet },
  { title: "AngryPI", component: AngryPi },
];



// WEBPACK FOOTER //
// ./src/components/projects/all.js